<script>
import KlubiVnos from "./Klubi_vnos.vue"
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/Sifranti_Klubi-sl.json';
import en from '@/Prevodi/Sifranti_Klubi-en.json';
import it from '@/Prevodi/Sifranti_Klubi-it.json';
export default {
  components: {
    'KlubiVnos': KlubiVnos,
    Notification
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      prikaz: 'vnosi',
      klubi: [],
      izbranKlub: [],
      urejanje: false,
      idUrejanja: '',
      idIzbrisa: '',
      uNaziv: '',
      uNaslov: '',
      uEmail: '',
      uTel: '',
      text: '',
      types: '',
      ShowNoti: false,
      pot: config.baseUrl,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.Read();
  },
  methods: {
    Read() {
      axios.get('./api/sifranti/klubi/izpis/').then((response) => {
        this.klubi = response.data.klubi;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Details(id) {
      this.izbranKlub = this.klubi.filter(klub => klub.id === id);
      $(this.$refs.modalKarticaKluba).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalKarticaKluba).modal('hide');
      this.izbranKlub = [];
      //ponastavitev podatkov
      this.urejanje = false;
      this.uNaziv = '';
      this.uNaslov = '';
      this.uPosta = '';
      this.uKraj = '';
      this.uEmail = '';
      this.uTel = '';
    },
    potrdiIzbris(id) {
      this.idIzbrisa = id;
      this.text = 'Ali res želite pobrisati zapis?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      let izbris = new URLSearchParams();
      izbris.append("id_brisanja", this.idIzbrisa);
      axios
          .post("./api/sifranti/klubi/brisi/", izbris)
          .then((response) => {
            // $(this.$refs.modalObracunMotZapisa).modal('hide');
            this.Read();
            this.DetailsOff();
            // alert(text);
            this.text = "Zapis uspešno pobrisan";
            this.types = "Uspešno";
            this.ShowNoti = true;
            this.idIzbrisa = '';
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri brisanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri brisanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    UrediZapis(id) {
      this.idUrejanja = id;
      this.urejanje = true;
      this.uNaziv = this.izbranKlub[0].naziv;
      this.uNaslov = this.izbranKlub[0].naslov;
      this.uPosta = this.izbranKlub[0].posta;
      this.uKraj = this.izbranKlub[0].kraj;
      this.uEmail = this.izbranKlub[0].email;
      this.uTel = this.izbranKlub[0].tel;
    },
    PosodobiZapis() {
      var podatki = new URLSearchParams();
      podatki.append('idU', this.idUrejanja);
      podatki.append('sNaziv', this.izbranKlub[0].naziv);
      podatki.append('naziv', this.uNaziv);
      podatki.append('naslov', this.uNaslov);
      podatki.append('posta', this.uPosta);
      podatki.append('kraj', this.uKraj);
      podatki.append('tel', this.uTel);
      podatki.append('email', this.uEmail);
      axios.post('./api/sifranti/klubi/uredi/', podatki, {withCredentials: true}).then((response) => {
        this.izbranKlub[0].naziv = this.uNaziv;
        this.izbranKlub[0].naslov = this.uNaslov;
        this.izbranKlub[0].posta = this.uPosta;
        this.izbranKlub[0].kraj = this.uKraj;
        this.izbranKlub[0].email = this.uEmail;
        this.izbranKlub[0].tel = this.uTel;
        //ponastavitev podatkov
        this.urejanje = false;
        this.uNaziv = '';
        this.uNaslov = '';
        this.uEmail = '';
        this.uTel = '';
        // alert('podatki posodobljeni!');
        this.text = 'podatki posodobljeni!';
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri posodabljanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri posodabljanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    IzvozCSV() {
      var podatki = new URLSearchParams();
      podatki.append('sifrantK', JSON.stringify(this.klubi));
      axios.post('./api/sifranti/csv/ ', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('main.title')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnosi'}" @click="prikaz = 'vnosi'">
              <i class="fas fa-edit"></i>
              <span>{{$t('navs.vnos')}}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'branje'}" @click="prikaz = 'branje'">
              <i class="fas fa-list"></i>
              <span>{{$t('navs.seznam')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <klubi-vnos v-if="prikaz=='vnosi'" @osvezi="Read()"/>
  <div v-else class='container p-4'>
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti=false" @closeNotification="ShowNoti = false" />
    </Transition>
    <br>
    <div class="pregled-povrsin-container">
      <div class='section-content'>
        <h4 class="text-white">
          <button class='btn btn-sm btn-outline-warning' :disabled="!klubi.length > 0" @click.prevent="IzvozCSV">
            {{$t('buttons.csv')}} <i class="fas fa-file-csv"></i>
          </button>
        </h4>
        <div class="desktop-grid">
          <div class="grid-container">
            <!-- Header row -->
            <div class="grid-header d-flex justify-content-between">
              <div class="grid-cell surface-label">{{$t('table.sifra')}}</div>
              <div class="grid-cell text-center">{{$t('table.naziv')}}</div>
              <div class="grid-cell text-center">{{$t('table.naslov')}}</div>
              <div class="grid-cell text-center">{{$t('table.podrobno')}}</div>
            </div>

            <!-- data row -->
            <div class="grid-row d-flex justify-content-between" v-for='klub in klubi' @click.prevent='Details(klub.id)'>
              <div class="grid-cell text-white surface-label">{{klub.sifra}}</div>
              <div class="grid-cell text-white text-center">{{klub.naziv}}</div>
              <div class="grid-cell text-white text-center">{{klub.naslov}}</div>
              <div class="grid-cell text-white text-center">
                <button type="button"
                        class="btn btn-primary mb-3"
                        @click.prevent='Details(klub.id)'>
                  <span><i class="far fa-id-card"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile/Tablet Multi-Select View -->
        <div class="mobile-multiselect">
          <div class="remarks-item">
            <div class="area-selection">
              <div class="area-group d-flex justify-content-between">
                <div class="text-white text-center">{{$t('table.sifra')}}</div>
                <div class="text-white text-center">{{$t('table.naziv')}}</div>
                <div class="text-white text-center">{{$t('table.podrobno')}}</div>
              </div>
              <div class="area-group d-flex justify-content-between" v-for='klub in klubi' @click.prevent='Details(klub.id)'>
                <div class="text-white text-center">{{klub.sifra}}</div>
                <div class="text-white text-start">{{klub.naziv}}</div>
                <div class="text-white text-center">
                  <button type="button"
                          class="btn btn-primary mb-3"
                          @@click.prevent='Details(klub.id)'>
                    <span><i class="far fa-id-card"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- KLUB PODROBNO -->
    <div class="modal modal-kartica" ref="modalKarticaKluba" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranKlub.length > 0" >
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="far fa-id-card fa-lg"></i> {{izbranKlub[0].naziv}}</h5>
          </div>
          <div class="modal-body col-12">
            <ul class='list-group list-group-flush' v-if="!this.urejanje">
              <li class='list-group-item list-dark'>{{$t('modal.sifra')}} {{izbranKlub[0].sifra}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naziv')}}{{izbranKlub[0].naziv}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naslov')}} {{izbranKlub[0].naslov}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.posta')}} {{izbranKlub[0].posta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.kraj')}} {{izbranKlub[0].kraj}}</li>
              <li class='list-group-item list-dark'>E-mail(upravitelja): {{izbranKlub[0].email}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.telefon')}} {{izbranKlub[0].tel}}</li>
            </ul>
            <ul class='list-group list-group-flush' v-else>
              <li class='list-group-item list-dark'>{{$t('modal.naziv')}} <span class='text-lorange'>{{izbranKlub[0].naziv}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaziv" v-model="uNaziv" required /></li>
              <li class='list-group-item list-dark'>{{$t('modal.naslov')}} <span class='text-lorange'>{{izbranKlub[0].naslov}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uNaslov" required /></li>
              <li class='list-group-item list-dark'>{{$t('modal.posta')}} <span class='text-lorange'>{{izbranKlub[0].posta}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uPosta" required /></li>
              <li class='list-group-item list-dark'>{{$t('modal.kraj')}} <span class='text-lorange'>{{izbranKlub[0].kraj}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uNaslov" v-model="uKraj" required /></li>
              <li class='list-group-item list-dark'>E-mail(upravitelja): <span class='text-lorange'>{{izbranKlub[0].email}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uEmail" v-model="uEmail" required /></li>
              <li class='list-group-item list-dark'>{{$t('modal.telefon')}} <span class='text-lorange'>{{izbranKlub[0].tel}}</span> <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="uTel" v-model="uTel" required /></li>
            </ul>
          </div>
          <div class="modal-footer col-12"><button class="btn btn-outline-warning" v-if="!this.urejanje" @click.prevent="UrediZapis(izbranKlub[0].id)"><i class="fas fa-user-edit"></i>{{$t('buttons.uredi')}}</button><button class="btn btn-outline-success" v-else @click.prevent="PosodobiZapis()"><i class="fas fa-sync-alt"></i> {{$t('buttons.posodobi')}}</button>&nbsp;<button class="btn btn-outline-danger" v-if="!this.urejanje" @click.prevent="potrdiIzbris(izbranKlub[0].id)">{{$t('buttons.brisi')}}</button></div>
        </div>
      </div>
    </div>
  </div>
</template>